import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { SaisieScreen } from '@/routes/supplier/rate-collection/saisie-screen';

// =============================================================================
// saisie-route.tsx — Adaptateur routeur de l'écran de SAISIE FOURNISSEUR (S12 / D2).
// =============================================================================
// La submission est la ressource d'URL (« /saisie/$submissionId »). Le filtre par famille
// (OPP-03) vit dans l'ÉTAT D'URL (search param `famille`, RULE_REF_006 : pas de localStorage
// pour l'état métier ni de vue). Le composant de présentation reste testable hors routeur.

const routeApi = getRouteApi('/saisie/$submissionId');

export function SaisieRoute(): React.JSX.Element {
  const { submissionId } = routeApi.useParams();
  // `famille` = filtre OPP-03 ; `cycle` = numéro de cycle d'affichage (F-10 visible si cycle ≥ 2) ;
  // `profil` = R15-CMP-03 : profil deep-linké depuis le catalogue (cellule focalisée à l'ouverture).
  const { famille, cycle, profil } = routeApi.useSearch();
  const navigate = useNavigate();

  const onSelectFamily = React.useCallback(
    (family: string | undefined): void => {
      void navigate({
        to: '/saisie/$submissionId',
        params: { submissionId },
        search: {
          ...(family !== undefined ? { famille: family } : {}),
          ...(cycle !== undefined ? { cycle } : {}),
          // Le profil deep-linké est préservé au changement de filtre (état d'URL cohérent).
          ...(profil !== undefined ? { profil } : {}),
        },
      });
    },
    [navigate, submissionId, cycle, profil],
  );

  return (
    <SaisieScreen
      submissionId={submissionId}
      selectedFamily={famille}
      onSelectFamily={onSelectFamily}
      cycle2={cycle !== undefined && cycle >= 2}
      cycleNumber={cycle}
      deepLinkProfile={profil}
    />
  );
}
